<script setup>
import { ref } from 'vue'

const links = ref([
	{
		label: 'Privacy Policy',
		href: 'https://www.snk-corp.co.jp/us/guide/policy',
	},
	{
		label: 'Terms of Service',
		href: 'https://www.snk-corp.co.jp/us/guide/terms',
	},
])

const socials = ref([
	{
		label: 'Twitter',
		icon: 'fab fa-x-twitter',
		href: 'https://x.com/snk_esports_hub',
	},
	{
		label: 'Instagram',
		icon: 'fab fa-instagram',
		href: 'https://instagram.com/snk_esports_hub',
	},
	{
		label: 'TikTok',
		icon: 'fab fa-tiktok',
		href: 'https://www.tiktok.com/@snk_esports_hub',
	},
])
</script>

<template>
	<footer class="bg-snk-blue-500 py-10 pb-40 text-snk-light-500">
		<div class="container">
			<div class="flex flex-col justify-between gap-10 sm:flex-row sm:gap-0">
				<div class="flex flex-col items-center gap-2 sm:items-start sm:gap-5">
					<img src="https://cdn.snkesports.com/events/images/logos/snk-esports-white.svg" alt="SNK Esports Logo" class="relative h-10" />
					<div class="flex gap-1">
						<a class="flex size-10 items-center justify-center rounded-full bg-snk-light-500 text-xl text-snk-blue-500 transition-transform duration-300 ease-in-out hover:-translate-y-1" v-for="social in socials" :href="social.href" target="_blank">
							<i :class="social.icon" />
						</a>
					</div>
				</div>
				<div class="flex flex-col items-end gap-5">
					<p class="uppercase">&copy; {{ new Date().getFullYear() }} SNK Corporation. All rights reserved.</p>
					<div class="flex gap-5">
						<a class="py-1 font-poppins text-sm font-bold uppercase" v-for="link in links" :href="link.href" target="_blank">{{ link.label }}</a>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>
